<template>
        <div class=" customization-detail-wrapper">
            <el-form :inline="true" :model="confirmData"  label-width="120px" ref="formName"  :rules="rules" >
                <div class="container padding-t20">
                    <div class="title flex-center"> <eui-icon icon="eicon-buser" font-size="18px" style="margin-right: 4px"></eui-icon>定制意向信息</div>
                    <div class="content-wrapper">
                        <div class="margin-l20 margin-t6">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="产品名称：">
                                        <div class="content-item" >
                                            <e-tooltip :content="baseData.productSkuName" :set-length="50" />
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="规格型号：">
                                        <div class="content-item" tyle="width: 280px;">
                                            <e-tooltip :content="baseData.purchaseOutSkuOptionsStr" :set-length="20" />
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="数量：">
                                        <div class="content-item" >{{baseData.purchaseOutQuantity}}</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="交货时间：">
                                        <div class="content-item" >{{baseData.deliveryDate ? baseData.deliveryDate.split(' ')[0] : ''}}</div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="交货地点：">
                                        <div class="content-item" style="width: 280px">
                                            <e-tooltip :content="baseData.deliveryAddress" :set-length="20" />
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="联系人：">
                                        <div class="content-item" >{{baseData.contactsName}}</div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联系电话：">
                                        <div class="content-item" >{{baseData.contactsPhone}}</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row class="flex">
                                <el-col :span="24" >
                                    <el-form-item label="备注：">
                                        <div class="content-item"style="width: 740px">
                                            <e-tooltip :content="baseData.remark" :set-length="200" /></div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="文件：">
                                        <div class="content-item attachment-list" >
                                            <div v-for="(item,index) in attachmentList" :key="index">
                                                <a :href="item.fileUrl" :download='item.fileName'  class="notice">{{item.fileName}}</a>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
                <div class="container padding-t20" >
                    <div class="title flex-center"> <eui-icon icon="eicon-suser" font-size="18px" style="margin-right: 4px"></eui-icon>确认定制信息</div>
                    <div class="content-wrapper confirm-data-wrapper">
                        <div class="margin-l20 margin-t6" style="padding-top: 10px">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="规格型号：" prop="skuOptionsStr">
                                        <el-input v-model="confirmData.skuOptionsStr" placeholder="请输入规格型号" maxlength="50" v-if=" flag === 'addInformation'"></el-input>
                                        <div v-else style="width: 280px;">
                                            <e-tooltip :content="confirmData.skuOptionsStr" :set-length="20" />
                                         </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="数量：" prop="quantity">
                                        <el-input v-model="confirmData.quantity" placeholder="请输入数量"
                                                  oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
                                                  if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                                  @input="confirmData.quantity = confirmData.quantity.replace( /[^0-9.]/g, '' )"
                                                  v-if=" flag === 'addInformation'" ></el-input>
                                        <div v-else>{{confirmData.quantity}}</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="单价（含税）：" style="margin-bottom: 8px" prop="price">
                                        <el-input v-model="confirmData.price" placeholder="请输入单价（含税）"
                                                  oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                                  @input="confirmData.price = confirmData.price.replace( /[^0-9.]/g, '' )"
                                                  v-if="flag === 'addInformation'"></el-input>
                                        <div v-else>{{confirmData.price}}</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-form>
            <div class="flex-c">
                <eui-btn type="secondary" @click="toBack">返 回</eui-btn>
                <eui-btn type="primary" @click="handleSupplierModify" v-if=" flag === 'addInformation'">确 认</eui-btn>
            </div>
        </div>
</template>

<script>
  import api from '../../api/order';
  import eTooltip from "../../components/common/e-tooltip";
  export default {
    components:{eTooltip},
     data() {
      return {
        input:'',
        baseData: {},
        attachmentList:[],
        disabledFlag:true,
        sourcingCustomizationId:'',
        flag:'',
        confirmData:{
          price:'',
          skuOptionsStr:'',
          quantity:'',
          unitName:'件',
          unitCode:12,
          subtotal:0,
        },
        rules: {
          skuOptionsStr: [{ required: true, message: '请输入规格型号', trigger: 'blur' }],
          quantity: [
            { required: true, message: '请输入数量', trigger: 'blur' },
            { pattern: /^(([1-9][0-9]{0,6})|0|10000000)$/, message: '最大为10000000', trigger: 'change' },
            ],
          price: [
            { required: true, message: '请输入单价（含税）', trigger: 'blur' },
            ],
         },

      }
    },
    methods:{
     async  supplierModify(){
       let res = await api.supplierModify(this.confirmData);
       if(res.success){
         this.$message.success('确认信息已提交成功!')
         this.toBack();
       }
      },
      handleSupplierModify(){
       const {quantity,price} = this.confirmData;
       if(Number(quantity) * Number(price) > 99999999.99){
            this.$message.warning('订单金额不能超过99999999.99，请核对订单。');
            return false;
       }
        this.$refs['formName'].validate((valid) => {
          if(valid){
            const {price,quantity} =  this.confirmData;
            this.confirmData.subtotal =  Number(Number(quantity) * Number(price)).toFixed(2);
            this.supplierModify();
          }
        });
      },
      toBack(){
        this.$router.back();
      },
      async supplierDetail(){
        let res = await api.supplierDetail({sourcingCustomizationId:this.sourcingCustomizationId});
        if(res.success){
          this.baseData = res.data || {};
          this.baseData.attachmentList.forEach(item=>{
            this.attachmentList.push({...item,name:item.fileName,url:item.fileUrl})
          });

            this.confirmData.price = this.baseData.price || '';
            this.confirmData.skuOptionsStr = this.baseData.skuOptionsStr || this.baseData.purchaseOutSkuOptionsStr;
            this.confirmData.quantity = this.baseData.quantity || this.baseData.purchaseOutQuantity;
            this.confirmData.sourcingCustomizationId = this.sourcingCustomizationId;
        }
      },
    },
    mounted() {
      this.sourcingCustomizationId = this.$route.query.sourcingCustomizationId;
      this.flag = this.$route.query.flag;
      this.supplierDetail();
    }
  }
</script>

<style scoped lang="scss">
    .customization-detail-wrapper {
        .padding-t20{
            padding-top: 20px;
        }
        .title {
            color: #333;
            font-size: 16px;
            margin-bottom: 10px;
            font-weight: 550;
        }
        .content-wrapper {
            .margin-t6{
                margin-top: 6px;
            }
            .content-item{
                color: #333;
            }
            .attachment-list{
                display: flex;
                flex-wrap: wrap;
                width: 600px;
                div{
                    margin-right: 40px;
                }
            }
            .el-form-item{
                margin-bottom: -5px;
                color: #666;
            }
            .el-form-item__label{
                color: #666;
            }
            .remark-box{
                ::v-deep  .el-input__inner{
                    width: 794px;
                    height: 60px;
                }
            }
            ::v-deep .el-col-24,.el-col-12{
                margin-bottom: 10px;
            }
        }
        .confirm-data-wrapper{
            ::v-deep .el-col-12{
                margin-bottom: 20px;
            }
        }
    }
</style>